import { PrivateLayout } from './containers'

export default PrivateLayout